<template>
  <div
    style="
      width: 90%;
      margin: auto;
      margin-top: 3rem;
      position: relative;
      z-index: 999;
    "
  >
    <div
      class="p-datatable p-component p-datatable-sm"
      v-if="jobOpeningsLoading"
    >
      <div class="p-datatable-tablewrapper">
        <table>
          <thead>
            <tr>
              <th
                v-for="item in 8"
                :key="item"
                style="
                  height: 70px;
                  background: #f1f1f1;
                  font-family: 'Jost';
                  padding-left: 86px;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 16px;
                  color: #103660;
                "
              >
                <div
                  class="p-skeleton p-mb-3"
                  style="width: 80%; height: 1.5rem"
                ></div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in 15" :key="item" style="">
              <td
                v-for="item in 8"
                :key="item"
                style="
                  height: 90px;
                  background: #ffffff;
                  font-family: 'Jost';
                  font-style: normal;
                  padding-left: 86px;
                  font-weight: 600;
                  font-size: 16px;
                  color: #103660;
                "
              >
                <div
                  class="p-skeleton p-mb-3"
                  style="width: 80%; height: 1.5rem"
                ></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <DataTable
      v-else
      ref="table"
      :value="jobOpenings"
      :paginator="true"
      selectionMode="single"
      :rows="10"
      :paginatorTemplate="{
        '640px': 'PrevPageLink PageLinks NextPageLink     CurrentPageReport',
        '960px': ' PrevPageLink PageLinks NextPageLink    CurrentPageReport',
        '1300px': 'PrevPageLink PageLinks NextPageLink    CurrentPageReport',
        default: ' PrevPageLink PageLinks NextPageLink    CurrentPageReport',
      }"
      responsiveLayout="scroll"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    >
      <Column
        style=""
        headerStyle="font-weight: 600;font-size:16px;line-height: 26px;color: #103660;background: #F1F1F1"
        bodyStyle="font-weight: 600;font-size:16px;line-height: 26px;color: #103660;text-align: center;"
      >
        <template #header>
          <div style="text-align: center; flex: 0 0 100%">Logo</div>
        </template>
        <template #body="{ data }">
          <img
            loading="lazy"
            v-tooltip="data.company_name"
            :src="logoURL + data.company_logo"
            :alt="data.company_logo"
            class="product-image"
          />
        </template>
      </Column>

      <Column
        field="company_name"
        :header="$t('companyName')"
        headerStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #103660;background: #F1F1F1;border-radius: 0px 0px 0px 0px;"
        bodyStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #444444;"
        sortable
        @click="detailJob(data)"
      >
        <template #body="{ data }">
          <div
            @click="detailJob(data)"
            style="
              font-family: 'Jost';
              font-style: normal;
              font-weight: 600;
              font-size: 16px;
              color: #444444;
              cursor: pointer;
            "
          >
            {{ data.company_name }}
          </div>
        </template>
      </Column>
      <Column
        field="short_name"
        :header="$t('name')"
        headerStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #103660;background: #F1F1F1;border-radius: 6px 0px 0px 0px;"
        bodyStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #444444;"
        sortable
        @click="detailJob(data)"
      >
        <template #body="{ data }">
          <div
            @click="detailJob(data)"
            style="
              font-style: normal;
              font-weight: 600;
              font-size: 16px;
              max-width: 200px;
              color: rgb(68, 68, 68);
            "
            class="slice pointer"
            :title="data.shortName"
          >
            {{ data.shortName ? data.shortName : data.short_name }}
          </div>
        </template>
      </Column>
      <Column
        field="locationCity.description"
        :header="$t('locationm')"
        headerStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #103660;background: #F1F1F1;border-radius: 0px 0px 0px 0px;"
        bodyStyle="font-family: 'Jost';font-style: normal;font-weight: 400;font-size: 16px;color: #444444;"
        sortable
      >
        <template #body="{ data }">
          <div style="display: flex">
            <img
              loading="lazy"
              src="/img/location.png"
              style="
                height: 25px;
                border-radius: 50%;
                padding: 0.4rem;
                background-color: #ffebcc;
                width: 22px;
                margin-right: 0.5rem;
              "
            />
            <span class="image-text">
              {{
                (data.locationCity
                  ? data.locationCity.description
                  : data.location_city_name
                  ? data.location_city_name + '/'
                  : '') +
                (data.locationCountry
                  ? data.locationCountry.description
                  : data.location_country_name)
              }}
            </span>
          </div>
        </template>
      </Column>
      <Column
        field="commissionFee"
        :header="$t('reward')"
        sortField="reward"
        headerStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #103660;background: #F1F1F1;border-radius: 0px 0px 0px 0px;"
        sortable
      >
        <template #body="{ data }">
          <label
            class="ch-currency"
            style="
              font-family: Jost;
              font-style: normal;
              font-weight: 700;
              font-size: 16px;

              color: rgb(252, 108, 42);
              background: #ffebcc;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            {{ formattedAmount(data) }}</label
          >
        </template>
      </Column>
      <Column
        field="jobType.createDate"
        :header="$t('createDate')"
        headerStyle="font-family: 'Jost';font-style: normal;font-weight: 600;font-size: 16px;color: #103660;background: #F1F1F1;border-radius: 0px 0px 0px 0px;"
        bodyStyle="font-family: 'Jost';font-style: normal;font-weight: 400;font-size: 16px;color: #444444;"
        sortable
        dataType="date"
      >
        <template #body="{ data }">
          <div style="display: flex">
            <img
              loading="lazy"
              src="/img/Calendar.png"
              style="
                border-radius: 50%;
                padding: 0.3rem;
                background-color: #ffebcc;
                width: 24px;
                margin-right: 0.5rem;
              "
            />
            <span class="image-text">{{
              formatDate(data.createDate ? data.createDate : data.create_date)
            }}</span>
          </div>
        </template>
      </Column>
      <Column headerStyle="background: #F1F1F1;border-radius: 0px 6px 0px 0px;">
        <template #body="{ data }">
          <div
            :style="{
              display: 'flex',
              flexDirection:
                data.show_refer == 1 || data.show_apply == 1 ? 'row' : 'column',
              gap: '5px',
            }"
          >
            <Button
              v-if="data.show_refer == 1"
              class="button-refer"
              :style="{
                flex: data.show_refer == 1 && data.show_apply == 1 ? '2' : '1',
              }"
              @click="refer(data)"
              :label="$t('refer')"
            />

            <Button
              v-if="data.show_apply == 1"
              class="button-apply"
              :style="{
                flex: data.show_refer == 1 && data.show_apply == 1 ? '2' : '1',
              }"
              @click="apply(data)"
              :label="$t('apply')"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import moment from 'moment'
import { logoURL } from '../api/Services'
import { mapGetters } from 'vuex'

export default {
  name: 'HomeDataTable',
  emits: ['refer-click', 'apply-click', 'detail-job'],
  data() {
    return {
      jobtype: null,
      jobtypes: null,
      worktype: null,
      dateposted: null,
      logoURL: logoURL,
    }
  },
  props: {
    jobOpenings: Array,
    jobOpeningsLoading: {
      type: Boolean,
      default: false,
    },
    topsize: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    refer(data) {
      this.$emit('refer-click', data)
    },

    apply(data) {
      this.$emit('apply-click', data)
    },
    detailJob(data) {
      const parameters = {
        name: this.toSeoUrl(
          `${data.company_name}-${data.short_name.replaceAll(' ', '_')}`
        ),
        id: data.id,
      }
      this.$emit('detail-job', parameters)
    },
    toSeoUrl(text) {
      // Küçük harfe çevir
      let seoText = text.toLowerCase()

      // Türkçe karakterleri İngilizce karşılıklarına çevir
      const map = {
        ç: 'c',
        ğ: 'g',
        ı: 'i',
        ö: 'o',
        ş: 's',
        ü: 'u',
        Ç: 'C',
        Ğ: 'G',
        İ: 'I',
        Ö: 'O',
        Ş: 'S',
        Ü: 'U',
      }

      seoText = seoText.replace(/[çğışüö]/g, (match) => map[match] || match)

      // Özel karakterleri ve boşlukları '-' ile değiştir
      seoText = seoText.replace(/[^a-z0-9]+/g, '-')

      // Başlangıç ve bitişteki '-' karakterlerini kaldır
      seoText = seoText.replace(/^-+|-+$/g, '')

      return seoText
    },
    formatDate(data) {
      return moment(String(data)).format('DD.MM.YYYY')
    },
  },
  computed: {
    ...mapGetters(['formattedAmount']), // formattedAmount getter'ını alıyoruz
  },
}
</script>

<style lang="scss" scoped>
@import '../App.scss';
::v-deep(label) {
  margin-bottom: 0px !important;
}

::v-deep(.p-paginator-bottom) {
  //   div{
  //     justify-content: flex-end;
  //     .p-paginator-prev{
  //       width: 50px;
  //     height: 50px;
  //     border: 1px solid #C2C2C2;
  //     border-radius: 6px;

  //     span{
  //       color: #015CAC;
  //     font-weight: bolder;
  //     font-size: 20px;
  //     }
  //     }
  // .p-paginator-pages{
  //   button{
  //     background: #015CAC !important;
  //     border-color: rgba(63, 81, 181, 0.12);
  //     color: #FFFFFF !important;
  //     font-family: 'Jost';
  //     font-style: normal;
  //     font-weight: 800;
  //     font-size: 18px;
  //     border-radius: 6px !important;
  //   }
  // }
  // .p-paginator-next{
  //   width: 50px;
  //     height: 50px;
  //     border: 1px solid #C2C2C2;
  //     border-radius: 6px;
  //     span{
  //       color: #015CAC;
  //     font-weight: bolder;
  //     font-size: 20px;
  //     }
  // }

  .p-paginator-current {
    box-sizing: border-box;
    position: absolute !important;
    width: 240px;
    height: 41px;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    font-family: 'Jost';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
  }
  // }
  // padding-bottom: 5rem;
  //     // border-bottom: 1px solid #CBCBCB;
}
table {
  font-family: 'Jost';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #103660;
  border-collapse: collapse;
  margin-left: 4rem;
  margin-top: 2rem;
}

td {
  text-align: left;
  //  padding: 8px;
}
.product-image {
  display: flex;
  max-width: 150px;
  width: 100%;
  max-height: 84px;
  aspect-ratio: 16/9;
  object-fit: contain;
  object-position: center;
  margin: 0 auto;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 500;
  color: #fff;
}
::v-deep(.p-datatable .p-column-header-content) {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 1600px) {
  .ch-currency {
    padding: 8px !important;
    font-size: 12px !important;
  }
}

.custom-skeleton {
  .p-skeleton {
    background-color: #f8f9fa;

    &::after {
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.4),
        rgba(255, 255, 255, 0)
      );
    }
  }
}

::v-deep(.p-datatable-loading-overlay) {
  background: rgba(255, 255, 255, 0.8);
}

::v-deep(.p-datatable-loading-icon) {
  display: none;
}
</style>
